import React from 'react'
import { PMTCFv2Inline } from '../PMTCFv2Inline/PMTCFv2Inline'

export const PMTCFv2InlineNeutral = (props) => {
  return (
    <PMTCFv2Inline {...props}/>   
  )
}
